export const pvPower = (totalLoadsEnergy, batteryAutonomy, hsp) => {
  const SYSTEM_EFFICIENCY = 0.8;
  const HOURS_PER_DAY = 24;
  const numerator = ((totalLoadsEnergy) * (batteryAutonomy / HOURS_PER_DAY));
  const denominator = (hsp * SYSTEM_EFFICIENCY);
  const pvPowerValue = numerator / denominator;
  return Math.round(pvPowerValue);
};
